module.exports = {
    // basic
    'deleted-by': 'deleted by',
    'deleted-on': 'deleted on',
    'a-user': 'a user',
    'restore': 'restore',
    'restore-all': 'restore all',

    // raw
    'recycle-bin-restore-file-help': `<strong>Restoring any one file will also restore the entry.</strong>`,
    'recycle-bin-well-deleted-help': `
        Neither these files nor the entry can be restored, because the well they belong to no longer exists.</br>
        They can still be downloaded.
    `,

    // template
    'recycle-bin-title': (words) => `Deleted files from "${words[0]}" on "${words[1]}"`,

};
